module.exports = __webpack_public_path__ + "static/media/IMG-6.862297e1.jpg";